"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
var React = require("react");
var theme_1 = require("../../utils/theme");
var ApDatePicker_styles_1 = require("./ApDatePicker.styles");
exports.Navbar = function (_a) {
    var date = _a.date, onPreviousClick = _a.onPreviousClick, onNextClick = _a.onNextClick, srcRange = _a.srcRange, className = _a.className;
    return (React.createElement(ApDatePicker_styles_1.NavContainer, { className: className },
        React.createElement(ApDatePicker_styles_1.PrevNavButton, { onClick: function () {
                if (!(date.getFullYear() === srcRange.from.getFullYear()
                    && date.getMonth() === srcRange.from.getMonth())) {
                    onPreviousClick();
                }
            }, iconName: "baseline_keyboard_arrow_left", iconProps: {
                iconColor: theme_1.colors.green1
            } }),
        React.createElement(ApDatePicker_styles_1.NextNavButton, { onClick: function () {
                if (!(date.getFullYear() === srcRange.to.getFullYear()
                    && date.getMonth() === srcRange.to.getMonth())) {
                    onNextClick();
                }
            }, iconName: "baseline_keyboard_arrow_right", iconProps: {
                iconColor: theme_1.colors.green1
            } })));
};
//# sourceMappingURL=NavBar.js.map